import backofficeService from '../../api/backoffice'
import bonventaService from '../../api/bonventa'

export default {
  Location: {
    getAll(params) {
      return bonventaService.Api().get('terminal/location', { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    getById(id, params) {
      return bonventaService.Api().get(`terminal/location/${id}`, { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    update(id, data) {
      return bonventaService.Api().put(`terminal/location/${id}`, data)
        .then(response => response.data)
        .catch((error) => { throw error })
    },
  },
  Organization: {
    getAll(params) {
      return bonventaService.Api().get('backOffice/organization', { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    getById(id, params) {
      return bonventaService.Api().get(`backOffice/organization/${id}`, { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
  },
  User: {
    getAll(params) {
      return bonventaService.Api().get('backOffice/user', { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
  },
  getCancelCurrentMonth(params) {
    return backofficeService.Api().get('api/cancelledStore', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCancelPreviousMonth(params) {
    return backofficeService.Api().get('api/cancelledStore', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCustomerCount() {
    return backofficeService.Api().get('api/getCustomerCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  getLastComment() {
    return backofficeService.Api().get('crm/api/comment/byDate')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getLastActivity() {
    return backofficeService.Api().get('api/activity/byDate')
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  complateTask(id, data) {
    return backofficeService.Api().put(`api/task/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getLastComments() {
    return backofficeService.Api().get('crm/api/comment/byDate')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getOpenLeads() {
    return backofficeService.Api().get('api/leadsCountById')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getOpenInvoiceCount() {
    return backofficeService.Api().get('api/getOpenInvoiceCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoicesCount() {
    return backofficeService.Api().get('api/getInvoicesCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSignUpData() {
    return backofficeService.Api().get('api/getSignUpData')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  

  getTicketEvent(id) {
    return backofficeService.Api().get(`api/getListOfUserAllTickets/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getLeadEvent(id) {
    return backofficeService.Api().get(`api/getListOfUserAllLeads/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  getPromotionCount() {
    return backofficeService.Api().get('api/promotionCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAllLeadCount() {
    return backofficeService.Api().get('api/getAllLeadCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
 
  getListOfUserDueLeads(id) {
    return backofficeService.Api().get(`api/getListOfUserDueLeads/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  allUserDueLeads() {
    return backofficeService.Api().get('api/allUserDueLeads')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getNewSignupCount() {
    return backofficeService.Api().get('api/getNewSignupCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getRevenueCurrentMonth(params) {
    return backofficeService.Api().get('api/revenue', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getRevenuePreviousMonth(params) {
    return backofficeService.Api().get('api/revenue', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCurrentMonthRevenueByProduct() {
    return backofficeService.Api().get(`api/revenueByProduct?month=current`)
      .then(response => response.data)
      .catch(error =>{ throw error})
  },
}
